module.exports = __webpack_public_path__ + "860e7e55ba512caf6676cf61740cd799.jpg";